import React from "react"
import Seo from "../components/seo"
import Layout from "../components/layout"
import { Link, graphql } from 'gatsby'
import SeminarList from "../components/seminar/seminar-list"
import SeminarTypes from "../components/seminar/seminar-types"
import SeminarStatus from "../components/seminar/seminar-status"
import LazyAndPreloadImage from "../functions/lazy_and_preload_image"
import "../styles/pc/page/seminar.scss"
import "../styles/sp/page/seminar.scss"

export default function SeminarPage({ data }) {
  return (
    <Layout isSeminar={true}>
      <Seo
        type="article"
        title="セミナー"
        description="あたりまえを問い直し、これからのことを探究したい。組織開発、人材育成のいろんな知見、ノウハウを知り、自組織に活かしたい。単純にいろんな人と対話して、何かを生み出して行きたい。こんな思いをお持ちの方、ぜひ我々と一緒に探究を深めてみませんか？？"
        bobyClassName="menu6"
        path="seminar"
      />
      <div className="wrapper seminar">
        {/*//////////////////////////////* ↓パンくずリスト * //////////////////////////////*/}
        <div className="breadcrumb">
          <Link to="/">Home</Link>　/　<Link to="/seminar" className="current">Seminar</Link>
        </div>
        {/*//////////////////////////////* ↑パンくずリスト * //////////////////////////////*/}

        {/*//////////////////////////////* ↓タイトル * //////////////////////////////*/}
        <div className="catch1">
          <div className="catch1_in">
            <div className="catch_title">
              <h2 className="maintitle"><span>Seminar</span></h2>
              <p className="subtitle"><span>一緒に探求する場</span></p>
            </div>
          </div>{/* catch_in */}
        </div>{/* /catch1 */}
        {/*//////////////////////////////* ↑タイトル * //////////////////////////////*/}
        <div className="wrapper_contents">
          <div className="main">
        {/*//////////////////////////////* ↓コンテンツ01 * //////////////////////////////*/}
        { Object.keys(data.conceptSeminars.edges).length ?
          <>
          <div className="contents_01">
            <div className="contents_in">
              <div className="padding_sp">{/* スマホのみ隙間 */}
                <div className="inner_title">
                  <div className="inner_title_in">
                    <h4 className="maintitle"><span>コンセプトセミナー</span></h4>
                    <p className="subtitle"><span>あたりまえを問い直し、これからを探求します</span></p>
                  </div>
                  <div className="more"><Link to="/seminar/category/concept"><span>view more</span></Link></div>
                </div>
                  <SeminarList data={data.conceptSeminars.edges} />
              </div>{/* padding_sp スマホのみ隙間 */}
            </div>{/* contents_in */}
          </div>{/* /contents */}
          </>
            : ''
          }
          {/*//////////////////////////////* ↑コンテンツ01 * //////////////////////////////*/}
          {/*//////////////////////////////* ↓コンテンツ02 * //////////////////////////////*/}
          { Object.keys(data.knowledgeSeminars.edges).length ?
            <>
            <div className="contents_01">
              <div className="contents_in">
                <div className="padding_sp">{/* スマホのみ隙間 */}
                  <div className="inner_title">
                    <div className="inner_title_in">
                      <h4 className="maintitle"><span>ナレッジセミナー</span></h4>
                      <p className="subtitle"><span>ジェイフィールの知見やノウハウを紹介します</span></p>
                    </div>
                    <div className="more"><Link to="/seminar/category/knowledge"><span>view more</span></Link></div>
                  </div>
                    <SeminarList data={data.knowledgeSeminars.edges} />
                </div>{/* padding_sp スマホのみ隙間 */}
              </div>{/* contents_in */}
            </div>{/* /contents */}
            </>
              : ''
            }
            {/*//////////////////////////////* ↑コンテンツ02 * //////////////////////////////*/}
            {/*//////////////////////////////* ↓コンテンツ03 * //////////////////////////////*/}
            { Object.keys(data.dialogueSeminars.edges).length ?
              <>
              <div className="contents_01">
                <div className="contents_in">
                  <div className="padding_sp">{/* スマホのみ隙間 */}
                    <div className="inner_title">
                      <div className="inner_title_in">
                        <h4 className="maintitle"><span>ダイアログコミュニティ</span></h4>
                        <p className="subtitle"><span>話そう、語ろう、生み出そう</span></p>
                      </div>
                      <div className="more"><Link to="/seminar/category/dialogue"><span>view more</span></Link></div>
                    </div>
                      <SeminarList data={data.dialogueSeminars.edges} />
                  </div>{/* padding_sp スマホのみ隙間 */}
                </div>{/* contents_in */}
              </div>{/* /contents */}
              </>
                : ''
              }
              {/*//////////////////////////////* ↑コンテンツ03 * //////////////////////////////*/}
              {/*//////////////////////////////* ↓コンテンツ04 * //////////////////////////////*/}
              { Object.keys(data.rrtSeminars.edges).length ?
                <>
                <div className="contents_01">
                  <div className="contents_in">
                    <div className="padding_sp">{/* スマホのみ隙間 */}
                      <div className="inner_title">
                        <div className="inner_title_in">
                          <h4 className="maintitle"><span>リフレクションラウンドテーブル®セミナー</span></h4>
                          <p className="subtitle"><span>ミンツバーグ教授とジェイフィールが共同開発した、<br className="sp_only" />日本初の「内省」プログラムを紹介します</span></p>
                        </div>
                        <div className="more more_sp_2"><Link to="/seminar/category/rrt"><span>view more</span></Link></div>
                      </div>
                          <SeminarList data={data.rrtSeminars.edges} />
                      </div>{/* padding_sp スマホのみ隙間 */}
                    </div>{/* contents_in */}
                  </div>{/* /contents */}
                  </>
                  : ''
                }
                {/*//////////////////////////////* ↑コンテンツ04 * //////////////////////////////*/}
                {/*//////////////////////////////* ↓コンテンツ05 * //////////////////////////////*/}
                <div className="contents_01">
                  { Object.keys(data.archiveSeminars.edges).length ?
                  <>
                  <div className="contents_in">
                    <div className="padding_sp">{/* スマホのみ隙間 */}
                      <div className="inner_title">
                        <div className="inner_title_in">
                          <h4 className="maintitle"><span className="title_en">Seminar Archive</span></h4>
                          <p className="subtitle"><span>開催が終了したセミナー一覧</span></p>
                        </div>
                        <div className="more"><Link to="/seminar/archive"><span>view more</span></Link></div>
                      </div>
                      <div className="flex_wrap">

                        {data.archiveSeminars.edges.map(({ node }) => (
                          <div className="flex_contents" key={node.seminarsId}>
                            <SeminarStatus status={node.status} />
                            <Link to={'/seminar/' + node.seminarsId}>
                              <div className="contents_box">
                                <LazyAndPreloadImage imgUrl={node.image ? node.image.url : ''} alt={"セミナーアーカイブ一覧"} />                                
                              </div>
                              <SeminarTypes types={node.types} />
                              <div className="seminar_title">{node.title}</div>
                              <div className="data">開催日程：{node.display_event_date}</div>
                              <div className="seminar_tag">
                                {node.tags.map((tag) => (
                                 tag.type[0] === "セミナータグ" ? <p key={tag.id}>#{tag.name}</p> : ''
                                ))}
                              </div>
                            </Link>
                          </div>
                        ))}

                      </div>
                    </div>{/* padding_sp スマホのみ隙間 */}
                  </div>{/* contents_in */}
                  </>

                  : ''
                  }
              </div>{/* /contents */}
              {/*//////////////////////////////* ↑コンテンツ05 * //////////////////////////////*/}
              </div>{/* main */}
              <div className="page_title fixed">
                <div className="right_page_ttl"><span className="vertical">Seminar - </span><span className="txt">一緒に探求する場</span></div>
              </div>{/* right page_title */}
            </div>{/*wrapper_contents*/}
          </div>{/*wrapper*/}
    </Layout>
  )
}

export const query = graphql`
query SeminarQuery {
  conceptSeminars: allMicrocmsSeminars(
    limit: 3,
    filter: {category: {eq: "コンセプト"}, status: {ne: "開催終了"}},
    sort: {fields: [publishedAt], order: DESC}
  ) {
  edges {
    node {
      seminarsId
        title
        image {
          url
        }
        status
        types
        display_event_date
        tags {
          id
          name
          type
        }
      }
    }
  }

  knowledgeSeminars: allMicrocmsSeminars(
    limit: 3,
    filter: {category: {eq: "ナレッジ"}, status: {ne: "開催終了"}},
    sort: {fields: [publishedAt], order: DESC}
  ) {
    edges {
      node {
        seminarsId
        title
        image {
          url
        }
        status
        types
        display_event_date
        tags {
          id
          name
          type
        }
      }
    }
  }

  dialogueSeminars: allMicrocmsSeminars(
    limit: 3,
    filter: {category: {eq: "対話"}, status: {ne: "開催終了"}},
    sort: {fields: [publishedAt], order: DESC}
  ) {
    edges {
      node {
        seminarsId
        title
        image {
          url
        }
        status
        types
        display_event_date
        tags {
          id
          name
          type
        }
      }
    }
  }

  rrtSeminars: allMicrocmsSeminars(
    limit: 3,
    filter: {category: {eq: "リフレクションラウンドテーブル"}, status: {ne: "開催終了"}},
    sort: {fields: [publishedAt], order: DESC}
  ) {
    edges {
      node {
        seminarsId
        title
        image {
          url
        }
        status
        types
        display_event_date
        tags {
          id
          name
          type
        }
      }
    }
  }

  archiveSeminars: allMicrocmsSeminars(
    limit: 3,
    filter: {status: {eq: "開催終了"}},
    sort: {fields: [publishedAt], order: DESC}
  ) {
    edges {
      node {
        seminarsId
        title
        image {
          url
        }
        status
        types
        display_event_date
        tags {
          id
          name
          type
        }
      }
    }
  }
}`
